/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chart.js v4 compatible configuration

var mode = 'light';
var fonts = {
  base: 'Open Sans',
};

// Colors
var colors = {
  theme: {
    default: '#172b4d',
    primary: '#5e72e4',
    secondary: '#f4f5f7',
    info: '#11cdef',
    success: '#2dce89',
    danger: '#f5365c',
    warning: '#fb6340',
  },

  black: '#12263F',
  white: '#FFFFFF',
  transparent: 'transparent',
};

// Example 1 of Chart inside src/views/Index.js (Sales value - Card)
let chartExample1 = {
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        grid: {
          color: colors.theme['primary'],
        },
        ticks: {
          callback: function (value) {
            if (!(value % 10)) {
              return '$' + value + 'k';
            }
          },
        },
        beginAtZero: true,
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || '';
            var yLabel = context.parsed.y;
            var content = '';

            if (label) {
              content += label + ': ';
            }

            content += '$' + yLabel + 'k';
            return content;
          },
        },
      },
    },
  },
  data1: (canvas) => {
    return {
      labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [
        {
          label: 'Performance',
          data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
        },
      ],
    };
  },
  data2: (canvas) => {
    return {
      labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [
        {
          label: 'Performance',
          data: [0, 20, 5, 25, 10, 30, 15, 40, 40],
        },
      ],
    };
  },
};

// Example 2 of Chart inside src/views/Index.js (Total orders - Card)
let chartExample2 = {
  options: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || '';
            var yLabel = context.parsed.y + ' mins';
            var content = '';
            if (label) {
              content += label + ': ';
            }
            content += yLabel;
            return content;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 14,
          },
          callback: function (value) {
            if (!(value % 10)) {
              return value;
            }
          },
        },
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: true,
        },
        ticks: {
          font: {
            weight: 'bold',
          },
        },
      },
    },
  },
  options2: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || '';
            var yLabel = context.parsed.y + ' steps';
            var content = '';
            if (label) {
              content += label + ': ';
            }
            content += yLabel;
            return content;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 14,
          },
        },
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: true,
        },
        ticks: {
          font: {
            weight: 'bold',
          },
        },
      },
    },
  },
  options3: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || '';
            var yLabel = context.parsed.y + ' m/sec';
            var content = '';
            if (label) {
              content += label + ': ';
            }
            content += yLabel;
            return content;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 14,
          },
          callback: function (value) {
            if (!(value % 10)) {
              return value;
            }
          },
        },
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: true,
        },
        ticks: {
          font: {
            weight: 'bold',
          },
        },
      },
    },
  },
  data: {
    labels: ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Walking Activity mins data',
        data: [25, 20, 27, 22, 17, 29, 22],
        maxBarThickness: 10,
        borderRadius: 6,
        backgroundColor: ['#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5'],
        borderColor: 'rgba(0,0,0,1)',
      },
    ],
  },
  data2: {
    labels: ['Week1', 'Week2', 'Week3', 'Week4'],
    datasets: [
      {
        label: 'Walking Activity mins data',
        data: [25, 20, 27, 22, 17, 29, 22],
        maxBarThickness: 10,
        borderRadius: 6,
        backgroundColor: ['#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5'],
        borderColor: 'rgba(0,0,0,1)',
      },
    ],
  },
  data3: {
    labels: ['12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM'],
    datasets: [
      {
        label: 'Walking Activity mins data',
        data: [25, 20, 27, 22, 17, 29, 22],
        maxBarThickness: 10,
        borderRadius: 6,
        backgroundColor: ['#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5', '#3f51b5'],
        borderColor: 'rgba(0,0,0,1)',
      },
    ],
  },
  fallReportsOption: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || '';
            var yLabel = context.parsed.y + ' falls';
            var content = '';
            if (label) {
              content += label + ': ';
            }
            content += yLabel;
            return content;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 14,
          },
          callback: function (value) {
            if (!(value % 10)) {
              return value;
            }
          },
        },
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: true,
        },
        ticks: {
          font: {
            weight: 'bold',
          },
        },
      },
    },
  },
};

module.exports = {
  chartExample1,
  chartExample2,
};
